// IncidentNodeSelectorField.jsx
import React, { useState, useEffect } from 'react';
import { change, Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import FormItem from '../../../common/forms/FormItem';
import Select from '../../../common/forms/select/Select';
import TextInput from '../../../common/forms/input/TextInput';
import { isRequired } from '../../../../utils/validators';

const IncidentNodeSelectorField = ({
  nodes,
  fieldPrefix,
  dispatchChange,
  onPathChange,
  initialPath = [],
  label = "Tipo de incidencia",
}) => {
  const [path, setPath] = useState(initialPath || []);

  const clearFieldsFromLevel = (fromLevel) => {
    // eslint-disable-next-line no-plusplus
    for (let i = fromLevel; i < 10; i++) {
      dispatchChange(
        'IncidentRecordForm',
        `${fieldPrefix}.incidentNode-${i}`,
        null,
      );
      dispatchChange(
        'IncidentRecordForm',
        `${fieldPrefix}.incidentNodeNote-${i}`,
        null,
      );
    }
  };

  useEffect(() =>  () => {}, []);

  const toSelectOptions = (nodeList) =>
    nodeList.map((n) => ({
      value: n.id,
      label: n.label,
      noteRequired: n.noteRequired,
      children: n.children,
    }));

  const handleSelect = (levelIndex, selected) => {
    if (!selected) {
      clearFieldsFromLevel(levelIndex);
      const newPath = path.slice(0, levelIndex);
      setPath(newPath);
      onPathChange(newPath);
      return;
    }

    const levelNodes = levelIndex === 0 ? nodes : path[levelIndex - 1].children;
    const node = levelNodes.find((n) => n.id === selected.value);

    clearFieldsFromLevel(levelIndex + 1);

    const newPath = [...path.slice(0, levelIndex), node];
    setPath(newPath);
    onPathChange(newPath);
  };

  return (
    <>
      <FormGroup row>
        <FormItem label={label} required>
          <Field
            name={`${fieldPrefix}.incidentNode-0`}
            component={Select}
            options={toSelectOptions(nodes)}
            placeholder="Seleccionar..."
            onChange={(selected) => handleSelect(0, selected)}
          />
        </FormItem>
      </FormGroup>

      {path[0] && path[0].noteRequired && (
        <FormGroup row>
          <FormItem label="Motivo o Sustento" required>
            <Field
              name={`${fieldPrefix}.incidentNodeNote-0`}
              component={TextInput}
              type="textarea"
              placeholder="Motivo o Sustento"
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
      )}

      {path.map((selected, index) =>
        selected && selected.children && selected.children.length > 0 ? (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={`${selected.id}-${index}`}>
            <FormGroup row>
              <FormItem>
                <Field
                  name={`${fieldPrefix}.incidentNode-${index + 1}`}
                  component={Select}
                  options={toSelectOptions(selected.children)}
                  placeholder="Seleccionar..."
                  onChange={(val) => handleSelect(index + 1, val)}
                  validate={[isRequired]}
                />
              </FormItem>
            </FormGroup>

            {path[index + 1] && path[index + 1].noteRequired && (
              <FormGroup row>
                <FormItem label="Motivo o Sustento" required>
                  <Field
                    name={`${fieldPrefix}.incidentNodeNote-${index + 1}`}
                    component={TextInput}
                    type="textarea"
                    placeholder="Motivo o Sustento"
                    validate={[isRequired]}
                  />
                </FormItem>
              </FormGroup>
            )}
          </React.Fragment>
        ) : null,
      )}
    </>
  );
};

IncidentNodeSelectorField.propTypes = {
  nodes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      noteRequired: PropTypes.bool,
      children: PropTypes.arrayOf(PropTypes.number),
    }),
  ).isRequired,
  fieldPrefix: PropTypes.string.isRequired,
  dispatchChange: PropTypes.func.isRequired,
  onPathChange: PropTypes.func.isRequired,
  initialPath: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      noteRequired: PropTypes.bool,
      children: PropTypes.arrayOf(PropTypes.number),
    }),
  ),
  label: PropTypes.string,
};

IncidentNodeSelectorField.defaultProps = {
  label: "Tipo de incidencia",
  initialPath: [],
};

const mapDispatchToProps = {
  dispatchChange: change,
};

export default connect(null, mapDispatchToProps)(IncidentNodeSelectorField);
